module.exports = __webpack_public_path__ + "img/union.828523c.png";